import { DesktopDatePicker } from "@mui/x-date-pickers";

export default function DatePicker({ placeholder, error, ...others }) {
  return (
    <DesktopDatePicker
      className="saj-datepicker"
      disablePast
      format="dd/MM/yyyy"
      slotProps={{
        textField: {
          placeholder,
          size: "small",
          fullWidth: true,
          error,
          required: true,
          variant: "filled",
          color: "secondary",
        },
        inputAdornment: {
          position: 'start'
        },
        popper: {
          placement: 'left'
        }
      }}
      orientation="landscape"
      {...others}
    />
  );
}